import {subdebug} from '@sanity/cli-core'

export const debug = subdebug('typegen:generate')
